import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/**
 * renders HTML image tag associated to a SVG flag
 * @param {{countryCode: string, width: number|string}} object
 */

const Image = styled.img`
  border-radius: 50%;
  width: 25px;
  height: 25px;
`

export const FlagImage = ({ countryCode, width }) => (
  <Image src={`/register/assets/flags/${countryCode?.toLowerCase()}.png`} alt="" />
)

FlagImage.propTypes = {
  countryCode: PropTypes.string,
  width: PropTypes.string,
}
